<template>
  <div class="content">
    <step-navbar :current-step="4" :disable-btn="true"/>
    <div id="content">
      <div class="page-">
        <div class="container">
          <div class="page align-center">
            <h3 v-if="state === 0">{{$t('step5.page.title')}}</h3>
            <h4 v-if="state === 0"><span>{{$t('step5.page.subtitle.1')}}</span> {{$t('step5.page.subtitle.2')}}</h4>
          </div>
        </div>

        <div class="finalstep">
          <payment-success v-if="state === 1"/>
          <payment-failed v-if="state === 2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StepNavbar from "./step-navbar";
  import PaymentSuccess from "./step5/payment-success";
  import PaymentFailed from "./step5/payment-failed";
  let stripe = null;

  export default {
    name: "step5",
    components: {PaymentFailed, PaymentSuccess, StepNavbar},
    data () {
      return {
        payment_intent: null,
        payment_intent_client_secret: null,
        source_type: null,
        state: 0
      }
    },
    async mounted() {
      if (!stripe) {
        try {
          stripe = Stripe(process.env.STRIPE_PK);
        } catch (e) {
          console.error('Stripe not ready')
        }
      }

      await this.$store.dispatch('shoppingCart/init', {lang: this.$store.state.lang.currentLang});

      console.log(this.$route);
      if (this.$route.query.force) {
        this.state = parseInt(this.$route.query.force);
        return;
      }
      /** https://stripe.com/docs/payments/payment-intents/verifying-status **/
      const params = new URLSearchParams(window.location.search);
      this.payment_intent = params.get('payment_intent');
      this.payment_intent_client_secret = params.get('payment_intent_client_secret');
      this.source_type = params.get('source_type');
      stripe.confirmCardPayment(this.payment_intent_client_secret).then( async (response) => {
        if (response.paymentIntent && (response.paymentIntent.status === "succeeded" || response.paymentIntent.status === "processing" )) {
          // ....
          await this.$store.dispatch('shoppingCart/deleteCurrent');
          this.state = 1;
        } else if (response.paymentIntent && response.paymentIntent.status === "requires_actions") {
          if (!response.paymentIntent.next_action) {
            this.state = 2;
            return;
          }
          if (response.paymentIntent.next_action && response.paymentIntent.next_action.type === 'redirect_to_url') {
            window.location.assign(String(response.paymentIntent.next_action.redirect_to_url.url));
          } else if (response.paymentIntent.next_action && response.paymentIntent.next_action.type === 'three_d_secure_redirect') {
            window.location.assign(String(response.paymentIntent.next_action.stripe_js.url));
          }
        } else {
          this.state = 2;
        }
      })
    }
  }
</script>

<style scoped>
  h4 {
    font-family: 'Sofia Pro', sans-serif;
    color: var(--darker-orange);
  }
</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step5.vue